import React from 'react'

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'

import fileOutlined from 'images/icons/svg/new_item_page/file-outlined.svg'

function EmptyState() {
  const { tv } = useUseCaseTranslate()

  return (
    <div className="use-cases-area__body-empty-container">
    <img src={fileOutlined} alt="" />
    <span className="use-cases-area__body-empty-text">
      {tv('area.empty')}
    </span>
  </div>
  )
}

export default EmptyState
